angular.module('bb.history', ['ui.bootstrap']).directive('historyModal', () => {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      id: '=',
      type: '@',
    },
    controller: HistoryCtrl,
    template: '<ng-transclude ng-click="openModal()"></ng-transclude>',
  };
});

HistoryCtrl.$inject = ['$scope', '$uibModal'];
function HistoryCtrl($scope, modal) {
  $scope.openModal = () => {
    const modalInstance = modal.open({
      animation: true,
      size: 'lg',
      template: require('./history_modal.html'),
      scope: $scope,
      ...($scope.type === 'AppointmentConfig' && {
        windowClass: `bb-history-modal-appt-config`,
      }),
    });

    modalInstance.result.then(_, () => {});
  };
}

export {};
